<nav
  [attr.aria-label]="accessibilityConfig?.previewsContainerAriaLabel"
  [title]="accessibilityConfig?.previewsContainerTitle"
  class="previews-container"
>
  <ng-container *ngIf="configPreview?.visible">
    <a
      (click)="onNavigationEvent('left', $event)"
      (keyup)="onNavigationEvent('left', $event)"
      [attr.aria-label]="accessibilityConfig?.previewScrollPrevAriaLabel"
      [tabindex]="configPreview.arrows && start > 0 ? 0 : -1"
      class="nav-left"
      role="button"
    >
      <ng-container
        *ngIf="configPreview.arrows && start > 0; else emptyLeftPreviewArrow"
      >
        <app-icon
          [title]="accessibilityConfig?.previewScrollPrevTitle"
          aria-hidden="true"
          [iconName]="['Arrows', 'left']"
          [color]="'#007bff'"
          class="inside left-arrow-preview-image"
        ></app-icon>
      </ng-container>
      <ng-template #emptyLeftPreviewArrow>
        <div aria-hidden="true" class="inside empty-arrow-preview-image"></div>
      </ng-template>
    </a>

    <ng-container
      *ngFor="let preview of previews; trackBy: trackById; let index = index"
    >
      <img
        (click)="onImageEvent(preview, $event, clickAction)"
        (keyup)="onImageEvent(preview, $event, keyboardAction)"
        *ngIf="preview?.modal?.img"
        [attr.aria-label]="preview.modal.ariaLabel ? preview.modal.ariaLabel : ''"
        [sizeConfig]="{width: configPreview.size ? configPreview.size.width : defaultPreviewSize.width,
                                 height: configPreview.size ? configPreview.size.height : defaultPreviewSize.height}"
        [src]="getUrlForMediaType(preview)"
        [tabindex]="0"
        [title]="preview.modal.title ? preview.modal.title : ''"
        alt="{{preview.modal.alt ? preview.modal.alt : ''}}"
        class="inside preview-image {{isActive(preview) ? 'active' : ''}}{{!configPreview.clickable ? ' unclickable' : ''}}"
        ksSize
        role="img"
      />
    </ng-container>

    <a
      (click)="onNavigationEvent('right', $event)"
      (keyup)="onNavigationEvent('right', $event)"
      [attr.aria-label]="accessibilityConfig?.previewScrollNextAriaLabel"
      [tabindex]="configPreview.arrows && end < images.length ? 0 : -1"
      class="nav-right"
      role="button"
    >
      <ng-container
        *ngIf="configPreview.arrows && end < images.length; else emptyRightPreviewArrow"
      >
        <app-icon
          [title]="accessibilityConfig?.previewScrollNextTitle"
          aria-hidden="true"
          [iconName]="['Arrows', 'right']"
          [color]="'#007bff'"
          class="inside right-arrow-preview-image"
        ></app-icon>
      </ng-container>
      <ng-template #emptyRightPreviewArrow>
        <div aria-hidden="true" class="inside empty-arrow-preview-image"></div>
      </ng-template>
    </a>
  </ng-container>
</nav>
